import { Component, Input, OnInit } from "@angular/core";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { ListOption } from "../models/list-option";
//import { ListOption } from "src/shared/service-proxies/service-proxies";

@Component({
  selector: "ui-check-box-input",
  styleUrls: ["./ui-styles.css"],
  template: `<section
    class="example-radio-group"
    *ngIf="currentQuestion?.dataTypeName == 'checkbox'"
    color="primary"
  >
    <mat-slide-toggle
      color="primary"
      class="checkbox-slides"
      *ngFor="let option of currentQuestion.options"
      [checked]="option.checked"
      (change)="checkboxSlideChanged($event, option)"
    >
      <span style="white-space: normal">
        {{ option.text }}
      </span></mat-slide-toggle
    >
    <mat-form-field
      *ngIf="currentQuestion?.answerText != null && currentQuestion?.answerText?.indexOf('Other: ') >= 0"
    >
      <input
        type="text"
        (change)="onInputChanged($event)"
        matInput
        name="{{ currentQuestion.questionFieldName }}-Other"
        placeholder="Enter Answer"
        [(ngModel)]="currentQuestion.otherText"
      />
    </mat-form-field>
  </section> `,
})
export class CheckBoxInputComponent implements OnInit {
  @Input() currentQuestion: any;

  constructor() { }

  ngOnInit() { }

  checkboxSlideChanged(event: MatSlideToggleChange, option: ListOption) {
   this.currentQuestion.answerText = "";

   option.checked = event.checked;
   this.currentQuestion.options.forEach((element) => {
     if (element.checked) {
       this.currentQuestion.answerText += element.value + "|";
     }
   });
   //let answerOptions = this.currentQuestion.answerText;
   this.currentQuestion.answerText = this.currentQuestion.answerText.slice(0, -1);
  }
  onInputChanged(event: any) {
   if (this.currentQuestion.answerText.indexOf('Other: ') >= 0) {
     this.currentQuestion.answerText = this.currentQuestion.answerText.replace(
       "Other: ", 'Other: ' + this.currentQuestion.otherText
     );
     console.log(event.target.value);
   }
  }
}
